var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"suspend-notice"},[_c('SVGIcon',{staticClass:"notification",attrs:{"icon":"memberCenter-notification","stroke":"transparent","fill":"var(--warning)"}}),_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }